<script lang="ts">
  import { setContext } from 'svelte'
  import { writable } from 'svelte/store'

  import Comment from '#components/svelte-comments/Comment.svelte'
  import type { CommentAuthorModel, CommentModel } from '#components/comments/CommentTypes'
  import type { CommentsStateType } from '#components/svelte-comments/MaterialComments.svelte'

  export let item: CommentModel & {
    author: CommentAuthorModel
  };

  const noop = () => {
  }

  const state = writable<CommentsStateType>({
    userId: null,
    isLoggedIn: false,
    isModer: false,
    isBanned: false,
    commentEditTime: 30,
    hideClaimLink: true,
    commentFormDisabled: true,
    threadsExpanded: true,
    orderedComments: [item.comment_id],
    comments: { [item.comment_id]: item },
    users: { [item.author.id]: item.author },
    loaded: true,
    failed: false,
    canHaveAnswer: false,
    canChooseAnswer: false,
    answerId: null,
    showSectionData: true,
    updateRating: noop,
    deleteComment: noop,
    deleteCommentChildren: noop,
    toggleHiddenThreads: noop,
    recursiveToggleHidden: noop,
    toggleChildren: noop,
    scrollToComment: noop,
    updateComment: noop,
    recursiveRecalc: noop,
    showEditForm: noop,
    showCommentForm: noop,
    hideCommentForm: noop
  })

  setContext('comments', state)
</script>

<Comment
  commentId={item.comment_id}
  hideButtons={true}
/>
